<script setup>
    import { onBeforeMount } from 'vue'
    import useChat from '@/composables/chat/useChat'
    import { maintainerData } from '@/composables/useLayouts'
    import { useChatStore } from '@/stores/chat'

    import Modal from '@/components/utils/Modal.vue'
    import NavbarChat from '@/views/chat/components/Navbar.vue'
    import ModalFactory from '@/views/chat/components/Modal/Modal.vue'
    import ConfigChat from '@/components/slide-overs/ConfigChat.vue'

    const data = useChat.data
    const store = useChatStore()

    // Define layout primary color
    onBeforeMount(() => {
        document.body.style.setProperty('--chatPrimary', maintainerData.value.color_primary)
        document.body.style.setProperty('--chatShadow', maintainerData.value.color_shadow)
        document.querySelector('link[rel*=\'icon\']').href = maintainerData.value.logo_small
    })
</script>

<template>
    <ModalFactory />

    <div
        class="layout_container chat_transition"
    >
        <div class="w-full">
            <NavbarChat :class="{ '-left-full': store().layout.showAttendanceInMobile }" />

            <main
                class="w-full relative h-full flex"
                :class="[
                    { 'pl-14 md:pl-20': !store().layout.showAttendanceInMobile },
                    'chat_transition'
                ]"
            >
                <RouterView />
            </main>
        </div>
    </div>

    <ConfigChat
        :show="store().layout.showPreferencesSlideOver"
        @close-config="store().togglePreferencesSlideOver"
    />

    <Modal
        :show="data.loading.modal"
        :type="data.loading.type"
        :title="data.loading.title"
        :content="data.loading.content"
        :fixed="true"
        @close-modal="() => {}"
    />
</template>
 
<style lang="scss">
.layout_container {
  @apply flex flex-wrap flex-col w-full h-full min-h-screen top-0;
  @apply bg-gradient-to-t from-[#E0EBFD] to-white;
  @apply dark:from-neutral-800 dark:to-neutral-800;
  background-position: top;
}
</style>
